<template>
  <form class="form-horizontal" v-on:submit.prevent>
    <div class="form-group row">
      <div class="col-xs-12 col-sm-5 col-md-3">
        <select class="form-control" v-model="attribute" v-on:change="emit()">
          <option v-for="field in this.attributes" v-bind:key="field.value" :value="field">Buscar por {{field.label}}</option>
        </select>
      </div>
      <div class="col-xs-12 col-sm-7 col-md-9">
        <input type="text" class="form-control"
          v-bind:placeholder="placeholder" v-on:keyup="updateFilter($event)">
      </div>
    </div>
  </form>
</template>

<script>
import _ from 'lodash'

export default {
  created() {
    this.search = _.debounce((value, loading, component) => {
      if (component.filter !== value) {
        component.filter = value
        component.emit()
      }
    }, this.delay)
  },
  data() {
    return {
      attribute: this.attributes[0],
      filter: ''
    }
  },
  props: {
    attributes: {type: Array, default: () => [{ value: 'name', label: 'nome' }]},
    delay: { type: Number, default: 350 }
  },
  methods: {
    updateFilter($event) {
      this.search($event.target.value, null, this)
    },
    emit() {
      this.$emit('filter', { field: this.attribute.value, value: this.filter })
    }
  },
  computed: {
    placeholder() {
      return `${this.attribute.label[0].toUpperCase()}${this.attribute.label.substring(1)}...`
    }
  }
}
</script>

<style scoped>
  @media (max-width: 767px) {
    [class*="col-"] {
      margin-bottom: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ListFilter.vue